export const getCurrentUrl = (): string => {
  return encodeURIComponent(
    window.location.pathname + window.location.search + window.location.hash
  );
};
